"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCnpj = normalizeCnpj;
exports.validCnpj = validCnpj;
exports.maskCnpj = maskCnpj;
const normalize_1 = require("./normalize");
const CNPJ_LENGTH = 14;
const DV1_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const DV2_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
// Alphanumeric CNPJ (IN RFB 2.229/2024): each character contributes charCodeAt(0) - 48.
// '0'..'9' -> 0..9 ; 'A'..'Z' -> 17..42.
function charValue(ch) {
    return ch.charCodeAt(0) - 48;
}
function checkDigit(base, weights) {
    let sum = 0;
    for (let i = 0; i < base.length; i++) {
        sum += charValue(base[i]) * weights[i];
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
}
function normalizeCnpj(value) {
    return (0, normalize_1.onlyAlnum)(value).slice(0, CNPJ_LENGTH);
}
function validCnpj(value) {
    if (!value)
        return false;
    const cnpj = (0, normalize_1.onlyAlnum)(value);
    if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(cnpj))
        return false;
    if (/^(\d)\1{13}$/.test(cnpj))
        return false;
    const dv1 = checkDigit(cnpj.slice(0, 12), DV1_WEIGHTS);
    const dv2 = checkDigit(cnpj.slice(0, 13), DV2_WEIGHTS);
    return dv1 === Number(cnpj[12]) && dv2 === Number(cnpj[13]);
}
function maskCnpj(value) {
    const v = normalizeCnpj(value);
    let out = '';
    for (let i = 0; i < v.length; i++) {
        if (i === 2 || i === 5)
            out += '.';
        else if (i === 8)
            out += '/';
        else if (i === 12)
            out += '-';
        out += v[i];
    }
    return out;
}
